import { MainDiv, ToolBarWrapper } from './style';
import RoofEditorTool from './Roof';
import SolarEditorTool from './Solar';

export default function EditorToolBar({ designType }: { designType: DesignType }) {
	return (
		<MainDiv>
			<ToolBarWrapper className='toolbar-wrap'>
				{designType === 'ROOF' ? <RoofEditorTool /> : <SolarEditorTool />}
			</ToolBarWrapper>

		</MainDiv>
	);
}